import React from 'react'

const StdLeaveDetails = () => {
  return (
    <div>
      <h1>Leave Details</h1>
    </div>
  )
}

export default StdLeaveDetails
